class APIError extends Error {
    code: number;
    referenceItems: any[];

    constructor(message: string, code = 0, referenceItems: unknown[] = []) {
        super(message);
        this.name = "APIError";
        this.message = message || "The API call returned an error.";
        this.code = code;
        this.stack = new Error().stack;
        this.referenceItems = referenceItems;
    }
}

export default APIError;
